import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";

const TerminosYcondiciones = () => {
  return (
    <Box textAlign="justify">
      <Typography variant="body2">
        Lea detenidamente el acuerdo de inscripción en el sistema de gestión de
        proyectos Jupiter, en el cual se determinan algunos aspectos relevantes
        que debe tener en cuenta antes de realizar su inscripción, y aceptar, si
        así lo deciden.
      </Typography>
      <br />
      <Typography variant="body2">
        La información suministrada será almacenada en las bases de datos de la
        Facultad de Ingeniería y serán utilizadas para:
      </Typography>
      <ul>
        <li>
          <Typography variant="body2">
            Activación de usuario y asignación de rol o perfil en el sistema,
            definido por la Unidad Académica a la cual se encuentra inscrito.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Verificación de la trazabilidad del movimiento de registros en el
            sistema, asociado al usuario asignado en el sistema.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Comunicaciones administrativas y técnicas sobre el sistema Júpiter.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Suministro de información a las autoridades competentes en caso de
            ser requerida.
          </Typography>
        </li>
      </ul>
      <br />
      <Typography variant="body2">
        En virtud del artículo 8 de la ley 1581 de 2013, el titular de la
        información personal que es recopilada en este formulario, tiene los
        siguientes derechos:
      </Typography>
      <ul>
        <li>
          <Typography variant="body2">
            Conocer, actualizar, rectificar y suprimir los datos suministrados.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Conocer los usos que se han hecho de la información suministrada,
            cuando así lo solicite el titular.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Revocar la autorización y/o solicitar la supresión del dato
            suministrado cuando en el Tratamiento realizado no se respeten los
            principios, derechos y garantías constitucionales y legales a favor
            del titular.
          </Typography>
        </li>
        <li>
          <Typography variant="body2">
            Acceder en forma gratuita a sus datos personales que hayan sido
            objeto de Tratamiento.
          </Typography>
        </li>
      </ul>
      <br />
      <Typography variant="body2">
        El titular de la información suministrada, podrá ejercer cualquiera de
        los derechos mencionados, dirigiendo una petición en este sentido a la
        dirección electrónica <b>vicedecaingenieria@udea.edu.co.</b> Recibida la
        solicitud en los términos dispuestos por la Universidad, se le dará
        trámite al requerimiento según lo establecido por la ley.
      </Typography>
      <br />
      <Typography variant="body2">
        Autorizo a la Universidad de Antioquia a realizar el tratamiento de mis
        datos personales tal y como lo dispone el Art. 15 de la Constitución
        Política Nacional, las Leyes estatutaria 1266 de 2008, la Ley
        estatutaria 1581 de 2012, y sus Decretos reglamentarios sus Decretos
        Reglamentarios, Decreto 1727 de 2009, Decreto 2952 de 2010, Decreto 1377
        de 2013 y Decreto 886 de 2014. Para realizar el proceso de inscripción
        debe aceptar las <b>POLÍTICAS DE TRATAMIENTO DE LA INFORMACIÓN PERSONAL </b> 
        marcando la casilla de comprobación que indica <b>&ldquo;ESTOY DE ACUERDO&rdquo;.</b>
      </Typography>
    </Box>
  );
};

export default TerminosYcondiciones;
